import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Contact from "./components/Contact";
import AboutMe from "./components/AboutMe";
import Resume from "./components/Resume/Resume";
import WebApps from "./components/WebApps/WebApps";
import TlDr from "./components/TlDr/TlDr";
import Javascript from "./components/Javascript/Javascript";
import TopFaq from "./components/Resume/TopFaq";
import Cpp from "./components/Cpp/Cpp";
import "./App.css";

const App = () => (
  <div>

    <nav className="navbar navbar-expand-sm bg-dark navbar-dark top-nav">

      <a className="navbar-brand" href="/AboutMe"
      >Charles W. Roberts</a>

      <li className="nav-item">
        <a className="nav-link" data-name="resume"
          href="/Resume">Resume</a>
      </li>

      <li className="nav-item">
        <a className="nav-link" data-name="faq"
          href="/TopFaq">FAQ</a>
      </li>

      <li className="nav-item">
        <a className="nav-link" data-name="web_apps"
          href="/WebApps">Web Applications</a>
      </li>

      <li className="nav-item">
        <a className="nav-link" data-name="contact"
          href="/Contact">Contact</a>
      </li>

      <li className="nav-item">
        <a className="nav-link" data-name="Javascript"
          href="/Javascript">Javascript</a>
      </li>

      <li className="nav-item">
        <a className="nav-link" data-name="Cpp"
          href="/Cpp">C / C++</a>
      </li>

      <li className="nav-item">
        <a className="nav-link" data-name="TlDr"
          href="/TlDr">tl;dr</a>
      </li>

    </nav>

    <Router>
      <div>
        <Switch>
          <Route exact path="/" component={() => <AboutMe />} />
          <Route exact path="/AboutMe" component={() => <AboutMe />} />
          <Route exact path="/Resume" component={() => <Resume />} />
          <Route exact path="/TopFaq" component={() => <TopFaq />} />
          <Route exact path="/Contact" component={() => <Contact />} />
          <Route exact path="/WebApps" component={() => <WebApps />} />
          <Route exact path="/Cpp" component={() => <Cpp />} />
          <Route exact path="/Javascript" component={() => <Javascript />} />
          <Route exact path="/TlDr" component={() => <TlDr />} />
        </Switch>
      </div>
    </Router>
  </div>
);

export default App;







// WEBPACK FOOTER //
// ./src/App.js